// @flow strict

import React from 'react';
import { injectIntl } from 'react-intl';

// Styles
import { Title, FormContainer, FormBlock, FormLabel } from 'styles/common';
import { Message } from './styles';

// Components
import { PrimaryButton } from 'components/_ReactUI_V1';

// Constants
import { CIRCUIT_ELEVATION_STEPS } from 'utils/constants';

// Helpers
import { getImportURLForPlant } from 'utils/helpers';

// Types
import type { IntlType } from 'types';

type Props = {
    intl: IntlType,
    plantId: number,
    isDownloadingTemplate: boolean,
    handleDownloadClicked: (plantId: number, fileName: string) => void,
};

class CircuitElevationDoneStep extends React.PureComponent<Props, null> {
    STEP_KEY = CIRCUIT_ELEVATION_STEPS.DONE;

    getTranslation = (id: string, data: ?Object) =>
        this.props.intl.formatMessage(
            {
                id: `components.CircuitElevation.${this.STEP_KEY}.${id}`,
            },
            data
        );

    /**
     * When the user clicks the download button
     */
    handleDownloadClicked = () =>
        this.props.handleDownloadClicked(
            this.props.plantId,
            this.getTranslation('download.FileName', {
                plantId: this.props.plantId,
            })
        );

    render() {
        return (
            <FormContainer>
                <Title>{this.getTranslation('title')}</Title>

                <FormBlock>
                    <FormLabel>{this.getTranslation('instructions.Label')}</FormLabel>
                    <Message>{this.getTranslation('instructions.Message')}</Message>
                </FormBlock>

                <FormBlock fullWidth>
                    <FormLabel>{this.getTranslation('api.Label')}</FormLabel>
                    <Message>{getImportURLForPlant(this.props.plantId)}</Message>
                </FormBlock>

                <FormBlock>
                    <FormLabel>{this.getTranslation('download.Label')}</FormLabel>
                    <Message>{this.getTranslation('download.Message')}</Message>
                    <PrimaryButton
                        text={this.getTranslation('download.Button')}
                        loading={this.props.isDownloadingTemplate}
                        onClick={this.handleDownloadClicked}
                    />
                </FormBlock>
            </FormContainer>
        );
    }
}

export default injectIntl(CircuitElevationDoneStep);
